export default {
  // Zaptec Go
  zaptecGoTitle: 'Zaptec Go',
  zaptecGoSubtitle: 'Populær og pålidelig ladeboks',
  zaptecGoDesc: 'Zaptec Go er en af de mest populære ladebokse i Skandinavien. Robust kvalitet, smart design og nem opsætning.',
  
  // Zaptec Go 2
  zaptecGo2Title: 'Zaptec Go 2',
  zaptecGo2Subtitle: 'Næste generation ladeboks',
  zaptecGo2Desc: 'Zaptec Go 2 er den nyeste model med V2G-ready hardware og forbedret connectivity.',
  
  // NexBlue Edge 2
  nexblueTitle: 'NexBlue Edge 2',
  nexblueSubtitle: 'Prisvenlig kvalitetsladeboks',
  nexblueDesc: 'NexBlue Edge 2 giver dig solid kvalitet til en skarp pris. V2X ready og nem at installere.',
  
  // Common charger specs
  chargingPower: 'Ladeeffekt',
  upTo22kw: 'Op til 22 kW',
  upTo11kw: 'Op til 11 kW',
  connectivity: 'Tilslutning',
  wifi4g: 'Wi-Fi + 4G',
  wifiBluetooth: 'Wi-Fi + Bluetooth',
  warranty: 'Garanti',
  fiveYears: '5 år',
  weatherRating: 'Vejrbestandighed',
  ip54: 'IP54',
  
  // Features
  loadBalancing: 'Dynamisk load balancing',
  rfidAccess: 'RFID adgangskontrol',
  solarReady: 'Solcelleintegration',
  v2xReady: 'V2X ready',
  v2gReady: 'V2G ready (hardware)',
  
  // Installation
  installationTitle: 'Installation',
  installationIncluded: 'Installation inkluderet',
  installationOptional: 'Installation valgfri',
  professionalInstall: 'Professionel installation af autoriseret elektriker',
  installPrice: 'Installationspris',
  installFrom: 'Fra 1.300 kr.',
  
  // Order
  orderNow: 'Bestil nu',
  addToOrder: 'Tilføj til bestilling',
  selectInstallation: 'Vælg installation',
  withInstallation: 'Med installation',
  withoutInstallation: 'Uden installation',
  
  // Comparison
  compareChargers: 'Sammenlign ladebokse',
  mostPopular: 'Mest populær',
  bestValue: 'Bedste værdi',
  latestModel: 'Nyeste model',
  
  // Marketing pages
  chargerOnly: 'Kun ladeboks',
  chargerPlusEl: 'Ladeboks + El-aftale',
  getCompleteSetup: 'Få en komplet løsning med ladeboks og billig strøm',
  
  // Order section
  order: {
    orderYourCharger: 'Bestil din ladeboks',
    seeAllChargers: 'Se alle ladebokse',
    chargerAndInstallation: 'Ladeboks + Installation',
    chargerPrice: 'Ladeboks pris',
    chooseInstallation: 'Vælg installation',
    noInstallation: 'Uden installation',
    existingInstallation: 'Eksisterende installation',
    standardInstallation: 'Standard installation',
    noInstallationDesc: 'Hvis du selv sørger for installation eller allerede har en installeret stikledning.',
    noInstallation1: 'Du modtager ladeboksen direkte',
    noInstallation2: 'Du sørger selv for installation',
    noInstallation3: 'Kontakt autoriseret elektriker',
    existingInstallationDesc: 'Hvis du har en eksisterende stikledning fra en tidligere ladeboks.',
    existingInstallation1: 'Udskiftning af eksisterende ladeboks',
    existingInstallation2: 'Genbrug af eksisterende kabel',
    existingInstallation3: 'Korrekt opsætning og test',
    existingInstallation4: 'Fjernelse af gammel ladeboks',
    standardInstallationDesc: 'Komplet nyinstallation af ladeboks inkl. kabeltræk.',
    standardInstallation1: 'Op til 10 meter kabeltræk',
    standardInstallation2: 'Montering af ladeboks',
    standardInstallation3: 'Tilslutning til eltavle',
    standardInstallation4: 'Test og ibrugtagning',
    standardInstallation5: 'Oprydning efter arbejde',
    price: 'Pris',
    electricityPlan: 'El-aftale',
    electricityAtSpot: 'El til spotpris uden tillæg',
    included: 'Inkluderet',
    chooseElPlan: 'Vælg el-aftale',
    orderSummary: 'Din bestilling',
    charger: 'Ladeboks',
    consumptionBilling: 'forbrugsafregning',
    solarAgreement: 'Solcelleaftale',
    freeSolarProduction: 'Gratis produktionsaftale',
    freeServiceAgreement: 'Gratis serviceaftale',
    month: 'md',
    totalOneTime: 'Engangsbetaling i alt',
  },
};